import { FC, ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';

import Logo from '../../components/Logo';

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

const AuthShell: FC<AuthShellProps> = ({ title, subtitle, children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      px: 2,
      py: 5,
      bgcolor: '#eef4ff',
      backgroundImage:
        'radial-gradient(circle at 15% 15%, rgba(11,143,202,0.14), transparent 28%), radial-gradient(circle at 85% 85%, rgba(86,70,216,0.10), transparent 30%)',
    }}
  >
    <Paper
      elevation={0}
      sx={{
        width: 'min(440px, 100%)',
        p: { xs: 3, sm: 4 },
        border: '1px solid #dbe3ee',
        borderRadius: 3,
        boxShadow: '0 24px 64px rgba(15, 23, 42, 0.14)',
      }}
    >
      <Box sx={{ width: 180, mx: 'auto', mb: 3 }}>
        <Logo />
      </Box>
      <Typography
        component="h1"
        sx={{
          color: '#0f172a',
          fontSize: 26,
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{ color: '#64748b', textAlign: 'center', mt: 0.75, mb: 3 }}
      >
        {subtitle}
      </Typography>
      {children}
    </Paper>
  </Box>
);

export default AuthShell;
